// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import {
  IDynamicBindableValue,
  IDynamicSimpleText,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import {
  DataLoadingProperties,
  hasError,
  isLoading,
  LoadingStateWrapper,
  LoadingStateWrapperProperties,
} from './loading-state-wrapper-helpers';

export function conditionalMessage(
  id: string,
  provider: string,
  property: string,
  message: string,
  options?: { matchValue?: boolean; classes?: string[]; addClasses?: string[] },
): IDynamicSimpleText {
  const defaultClasses =
    options?.classes !== undefined
      ? options.classes
      : ['d-flex', 'flex-row', 'flex-shrink-0', 'text-muted'];
  const allClasses = [...defaultClasses, ...(options?.addClasses ?? [])];

  return {
    id,
    contentTypeId: 'dynamic-elements-simple-text',
    if: [
      'EQ',
      [
        options?.matchValue !== undefined ? options.matchValue : true,
        {
          provider,
          property,
        },
      ],
    ],
    styles: {
      classes: allClasses,
    },
    inputs: {
      text: message,
    },
  };
}

export function getDataLoadingProperties<T extends string>(
  dataProvider: IDynamicBindableValue,
  propertyKey: T,
  options?: { jsonParse?: boolean },
): DataLoadingProperties<T> {
  const loadingStateWrapperProperties: LoadingStateWrapperProperties = {
    loadingStateWrapper: {
      ...dataProvider,
      wrapWithLoadingState: true,
    },
    isLoading: isLoading(),
    hasError: hasError(),
  };

  const transformMethod = options?.jsonParse
    ? function (
        loadingStateWrapper: LoadingStateWrapper<string>,
      ): unknown | undefined {
        const data = loadingStateWrapper.data;
        if (data === undefined) {
          return;
        }
        return JSON.parse(data);
      }
    : function (
        loadingStateWrapper: LoadingStateWrapper<unknown>,
      ): unknown | undefined {
        return loadingStateWrapper.data;
      };

  const property = {
    [propertyKey]: {
      provider: 'self',
      property: 'loadingStateWrapper',
      filter: function (
        loadingStateWrapper: LoadingStateWrapper<unknown>,
      ): boolean {
        const doesHaveError = '__resolveValueError__' in loadingStateWrapper;
        return !doesHaveError && !loadingStateWrapper.isLoading;
      }.toString(),
      transform: transformMethod.toString(),
    },
  };

  return {
    ...loadingStateWrapperProperties,
    ...property,
  } as DataLoadingProperties<T>;
}
